import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { ActivitySubscriptions, ActivitySubscriptionUpdateData } from '@core/activities-types';
import { Helpers } from '@core/common-legacy';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsHttpService {
  protected readonly httpApi = inject(HttpApiService);

  public loadActivitySubscriptions(): Observable<ActivitySubscriptions> {
    return this.httpApi
      .get('/tracking/activity_subscriptions', null, null)
      .pipe(map(data => data.activitySubscriptions));
  }

  public updateActivitySubscription(
    payload: ActivitySubscriptionUpdateData,
  ): Observable<ActivitySubscriptions> {
    return this.httpApi.patch(
      '/tracking/activity_subscriptions/update_activity_subscriptions',
      null,
      {
        type: payload.type,
        value: payload.value,
        events: payload.events.map(Helpers.underscore),
      },
    );
  }

  public resetToDefaultActivitySubscriptionPerRole(): Observable<ActivitySubscriptions> {
    return this.httpApi
      .patch('/tracking/activity_subscriptions/reset_to_defaults', null, null)
      .pipe(map(data => data.activitySubscriptions));
  }
}
